import { Modal } from "react-bootstrap";

const CustomModal = ({
  show,
  onHide,
  isHeader = true,
  title,
  footer,
  size = "md",
  children,
  className,
  ...otherProps
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size={size}
      centered
      className={`rtl ${className}`}
      {...otherProps}
    >
      {isHeader && (
        <Modal.Header className="d-felx justify-content-between align-content-center">
          {title && <Modal.Title>{title}</Modal.Title>}
          <i
            className="fa fa-times"
            style={{ cursor: "pointer" }}
            onClick={onHide}
          />
        </Modal.Header>
      )}
      <Modal.Body>{children}</Modal.Body>
      {footer && <Modal.Footer>{footer}</Modal.Footer>}
    </Modal>
  );
};

export default CustomModal;
